var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{ref:"anchor",staticClass:"ui-sticky-actions",style:(_vm.placeholderStyle)},[_c('span',{ref:"content",staticClass:"ui-sticky-actions__content",class:{ 'is-floating': _vm.floating },style:(_vm.floatingStyle)},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }